import { QueryClient } from '@tanstack/react-query';

import type { QueryClientConfig } from '@tanstack/react-query';

/**
 * Shared QueryClient factory for ari and ari-cloud.
 *
 * Defaults match what both apps were inlining before this was extracted:
 *   - retry: 1 — one automatic retry then surface the error to the UI
 *   - refetchOnWindowFocus: false — connector / skill queries have 5min
 *     staleTime; refetching on every tab focus would spam the backend
 *
 * Apps can pass `overrides` to extend or override either defaults or
 * any other QueryClient field. Override `defaultOptions.queries` with
 * a merged object — TanStack doesn't deep-merge for you.
 */
export function createQueryClient(overrides?: QueryClientConfig): QueryClient {
  return new QueryClient({
    ...overrides,
    defaultOptions: {
      ...overrides?.defaultOptions,
      queries: {
        retry: 1,
        refetchOnWindowFocus: false,
        ...overrides?.defaultOptions?.queries,
      },
    },
  });
}
